export default "__VITE_ASSET__8dd4c6bf__"